import React, { useState } from 'react';

export interface PasteIngredientsProps {
  side: 'a' | 'b';
  busy: boolean;
  error?: string;
  onPaste: (text: string) => void;
  /** Absent while confirming an unverified list: that product is already with our team. */
  onSendToTeam?: () => void;
}

/** Fallback after three unreadable label photos: paste the list or send it to the team. */
export default function PasteIngredients({ side, busy, error, onPaste, onSendToTeam }: PasteIngredientsProps) {
  const [text, setText] = useState('');
  const id = `paste-ingredients-${side}`;
  return (
    <div className="stack-3" data-testid="label-fallback">
      <p className="t-small t-mute" style={{ margin: 0 }}>
        {onSendToTeam ? 'We could not read the label. Paste the list or let our team add it.' : 'We could not read the label. Paste the list from the pack instead.'}
      </p>
      <label htmlFor={id} className="t-small" style={{ fontWeight: 600 }}>Paste the ingredient list</label>
      <textarea
        id={id}
        rows={4}
        maxLength={8000}
        value={text}
        disabled={busy}
        onChange={(event) => { setText(event.target.value); }}
        placeholder="Aqua, Glycerin, Cetearyl Alcohol, …"
        className="compare-barcode-field__input"
        style={{ width: '100%', resize: 'vertical' }}
      />
      {error && <div className="notice notice--error" role="alert">{error}</div>}
      <div className="flex flex-col sm:flex-row gap-2">
        <button
          type="button"
          className="btn btn--primary btn--sm justify-center"
          disabled={busy || text.trim() === ''}
          onClick={() => { onPaste(text.trim()); }}
        >
          Check this list
        </button>
        {onSendToTeam && (
          <button type="button" className="btn btn--ghost btn--sm justify-center" disabled={busy} onClick={onSendToTeam}>
            Send to our team
          </button>
        )}
      </div>
    </div>
  );
}
